// extracted by mini-css-extract-plugin
module.exports = {"layout":"_4e5f713ae4--layout--onvhe"};